import { Button, Div } from '@codesuma/baseline'
import calendar, { IDayCell } from '../../../services/calendar'
import { CalendarSystem } from '../../../services/settings'
import customOccasions from '../../../services/custom-occasions'
import ownEvents from '../../../services/events'
import { dayStamp } from './task-list'
import { Section } from './section'
import style from './index.module.css'

type IUpcomingRow = { title: string, cell: IDayCell }

// The user's own events and occasions from today to the end of the month. In
// the month's last week the next month's first week comes along too, so a
// birthday on the 2nd is already in sight on the 28th. Emrouz's own events
// only, not the phone's — the same choice the day cell's mark makes. Today's
// events are left out: today's own section above already lists them, but
// today's occasions have no other place up there. Each day's events lead and
// its occasions follow, as on the month's list.
export const upcomingRows = (inMonth: IDayCell[]): IUpcomingRow[] => {
    const from = inMonth.findIndex(c => c.isToday)
    if (from < 0) return []
    const left = inMonth.length - from
    const today = inMonth[from]
    return Array.from({ length: left <= 7 ? left + 7 : left },
        (_, i) => calendar.dayAt(today.gy, today.gm, today.gd, i))
        .flatMap(cell => [
            ...(cell.isToday ? [] : ownEvents.forDay(cell)),
            ...customOccasions.forDay(cell),
        ].map(({ title }) => ({ title, cell })))
}

// The task row's shape: the title taking the width, a tap through to its day,
// and the day at the far end. The slide leaves the section out when there is
// nothing coming up. Emits 'day-open' for the page to route on.
export const Upcoming = (system: CalendarSystem, rows: IUpcomingRow[], scroller: HTMLElement) => {
    const base = Section('رویدادهای مهم پیش رو', scroller)
    // The Gregorian slide is LTR for its grid, but these titles are the user's
    // own prose — keep them reading right-to-left like the rest of the app.
    if (system === 'gregorian') base.attr('dir', 'rtl')

    for (const { title, cell } of rows) {
        const row = Div()
        row.addClass(style.task)

        const name = Button(title)
        name.addClass(style.taskTitle)
        name.on('click', () => base.emit('day-open', cell))
        row.append(name)

        const day = Div(dayStamp(cell, system))
        day.addClass(style.taskDate)
        row.append(day)

        base.list.append(row)
    }

    return base
}
